// @ts-check
/** @typedef {import('../types/api').InstagramFeedItem} InstagramFeedItem */

import api from '../utils/apiClient';
import { assertArray } from '../utils/apiGuards';

const instagramFeedService = {
  /**
   * @returns {Promise<InstagramFeedItem[]>}
   */
  getFeedItems: async () => {
    const data = await api.get('/api/admin/instagram-feed');
    assertArray(data, 'instagramFeedService.getFeedItems');
    return data;
  },

  /**
   * @param {string} postId
   * @returns {Promise<InstagramFeedItem>}
   */
  addFeedItem: (postId) => api.post('/api/admin/instagram-feed', { post_id: postId }),

  /**
   * @param {string} itemId
   * @returns {Promise<void>}
   */
  removeFeedItem: (itemId) => api.del(`/api/admin/instagram-feed/${itemId}`),

  /**
   * @param {Object[]} items
   * @returns {Promise<Object>}
   */
  reorder: (items) => api.patch('/api/admin/instagram-feed/reorder', items),
};

export default instagramFeedService;
